<template>
	<div class="status-skeleton-wrapper">
		<div class="content-wrapper">
			<div class="content-header">
				<Skeleton width="11rem" height="1.25rem" />
			</div>
			<div class="content-body">
				<div class="terms-skeleton-box">
					<Skeleton width="100%" height="0.875rem" class="mb-3" />
					<Skeleton width="98%" height="0.875rem" class="mb-3" />
					<Skeleton width="100%" height="0.875rem" class="mb-3" />
					<Skeleton width="85%" height="0.875rem" />
				</div>

				<div class="flex align-items-center mt-4 gap-2">
					<Skeleton shape="circle" size="1.25rem" />
					<Skeleton width="18rem" height="0.875rem" />
				</div>
			</div>
		</div>

		<div class="card submit-skeleton-card">
			<div class="flex justify-content-end">
				<Skeleton width="7rem" height="2.5rem" borderRadius="6px" />
			</div>
		</div>
	</div>
</template>

<style scoped>
.status-skeleton-wrapper {
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.terms-skeleton-box {
	background: #f8f9fb;
	border: 1px solid #e0e4ea;
	border-radius: 6px;
	padding: 16px 20px;
}

.submit-skeleton-card {
	padding: 1rem 1.25rem;
}
</style>
